import { darken } from 'polished';
import React from 'react';
import { useTheme } from 'styled-components';

/**
 * This component renders an icon that looks like a piece of opened mail.
 */
export const LogoOpenMail: React.FC<React.PropsWithChildren<unknown>> = (
  rest,
) => {
  const theme = useTheme();
  /* eslint-disable max-len */
  return (
    <svg
      viewBox="0 0 283 251"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <defs>
        <linearGradient
          x1="49.9990603%"
          y1="126.593306%"
          x2="49.9990603%"
          y2="-92.2699679%"
          id="linearGradient-1"
        >
          <stop
            stopColor={darken(0.2, theme.colors.primary)}
            stopOpacity="0"
            offset="0%"
          />
          <stop
            stopColor={darken(0.2, theme.colors.primary)}
            stopOpacity="0.7"
            offset="100%"
          />
        </linearGradient>
        <linearGradient
          x1="49.9697005%"
          y1="0.0153308856%"
          x2="49.9697005%"
          y2="100.896355%"
          id="linearGradient-2"
        >
          <stop
            stopColor={darken(0.2, theme.colors.primary)}
            stopOpacity="0"
            offset="0%"
          />
          <stop
            stopColor={darken(0.2, theme.colors.primary)}
            stopOpacity="0.7"
            offset="100%"
          />
        </linearGradient>
        <linearGradient
          x1="62.8517793%"
          y1="30.0719813%"
          x2="93.2735724%"
          y2="-17.1602041%"
          id="linearGradient-3"
        >
          <stop stopColor={theme.colors.primary} stopOpacity="0" offset="0%" />
          <stop
            stopColor={theme.colors.primary}
            stopOpacity="0.3"
            offset="100%"
          />
        </linearGradient>
      </defs>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-561.000000, -37.000000)">
          <g>
            <g>
              <g transform="translate(561.315599, 37.000000)">
                <path
                  d="M275.199033,250.440299 L7.33349456,250.440299 C3.52889964,250.440299 0.441112455,247.347761 0.441112455,243.537313 L0.441112455,82.0074627 C0.441112455,78.1970149 3.52889964,75.1044776 7.33349456,75.1044776 L275.199033,75.1044776 C279.003628,75.1044776 282.091415,78.1970149 282.091415,82.0074627 L282.091415,243.537313 C282.091415,247.347761 279.003628,250.440299 275.199033,250.440299 Z"
                  fill={theme.colors.primary}
                  fillRule="nonzero"
                />
                <path
                  d="M275.199033,250.440299 L7.33349456,250.440299 C3.52889964,250.440299 0.441112455,247.347761 0.441112455,243.537313 L0.441112455,237.297015 L137.847642,160.977612 C139.942926,159.81791 142.534462,159.81791 144.629746,160.977612 L282.091415,237.297015 L282.091415,243.537313 C282.091415,247.347761 279.003628,250.440299 275.199033,250.440299 Z"
                  fill="url(#linearGradient-1)"
                  fillRule="nonzero"
                />
                <path
                  d="M0.441112455,83.9402985 L0.441112455,82.8358209 C0.441112455,79.6880597 2.15042322,76.8164179 4.852237,75.3253731 L137.847642,1.38059701 C139.942926,0.220895522 142.534462,0.220895522 144.629746,1.38059701 L278.121403,75.5462687 C280.547521,76.9268657 282.091415,79.4671642 282.091415,82.2835821 L282.091415,83.9955224 L0.441112455,83.9955224 L0.441112455,83.9402985 Z"
                  fill={theme.colors.primary}
                  fillRule="nonzero"
                />
                <path
                  d="M141.376542,84.0507463 L0.441112455,83.9402985 L0.441112455,85.2656716 C0.441112455,91.4507463 5.45876663,96.5313433 11.68948,96.5313433 L22.1107618,96.5313433 C23.7649335,96.5313433 25.4191052,96.9179104 26.9078597,97.6910448 L141.376542,156.11791 L255.679807,97.6910448 C257.168561,96.9179104 258.822733,96.5313433 260.476904,96.5313433 L270.898186,96.5313433 C277.073761,96.5313433 282.146554,91.5059701 282.146554,85.2656716 L282.146554,83.9402985 L141.376542,84.0507463 Z"
                  fill={theme.colors.primary}
                  fillRule="nonzero"
                />
                <path
                  d="M278.176542,76.2089552 L144.684885,2.04328358 C142.589601,0.88358209 139.998065,0.88358209 137.902781,2.04328358 L4.90737606,75.9328358 C2.20556227,77.4238806 0.496251511,80.3507463 0.496251511,83.4432836 L0.496251511,83.9402985 L0.496251511,84.6029851 L0.496251511,85.2104478 C0.496251511,91.3955224 5.51390568,96.4761194 11.7446191,96.4761194 L22.1659008,96.4761194 C23.8200726,96.4761194 25.4742443,96.8626866 26.9629988,97.6358209 L138.674728,154.68209 C140.384039,155.565672 142.479323,155.565672 144.188634,154.68209 L255.734946,97.6358209 C257.2237,96.8626866 258.877872,96.4761194 260.532044,96.4761194 L270.953325,96.4761194 C277.1289,96.4761194 282.201693,91.4507463 282.201693,85.2104478 L282.201693,84.6029851 L282.201693,83.9402985 L282.201693,82.8910448 C282.091415,80.1298507 280.60266,77.5895522 278.176542,76.2089552 Z"
                  fill="url(#linearGradient-2)"
                  fillRule="nonzero"
                />
                <g
                  transform="translate(0.000000, 1.104478)"
                  fill={theme.colors.primary}
                  fillRule="nonzero"
                >
                  <path d="M141.266264,0.110447761 C140.108343,0.110447761 138.895284,0.386567164 137.847642,0.994029851 L4.852237,74.8835821 C2.15042322,76.3746269 0.441112455,79.3014925 0.441112455,82.3940299 L0.441112455,82.8910448 L0.441112455,83.5537313 L0.441112455,84.161194 L141.266264,7.17910448 L141.266264,0.110447761 Z" />
                  <path d="M141.266264,0.110447761 C142.424184,0.110447761 143.637243,0.386567164 144.684885,0.994029851 L277.68029,74.8835821 C280.382104,76.3746269 282.091415,79.3014925 282.091415,82.3940299 L282.091415,82.8910448 L282.091415,83.5537313 L282.091415,84.161194 L141.266264,7.17910448 L141.266264,0.110447761 Z" />
                </g>
                <g transform="translate(40.802902, 30.925373)">
                  <path
                    d="M197.342684,130.052239 L3.63917775,130.052239 C1.92986699,130.052239 0.551390568,128.671642 0.551390568,126.959701 L0.551390568,3.25820896 C0.551390568,1.54626866 1.92986699,0.165671642 3.63917775,0.165671642 L197.342684,0.165671642 C199.051995,0.165671642 200.430472,1.54626866 200.430472,3.25820896 L200.430472,127.014925 C200.375333,128.671642 198.996856,130.052239 197.342684,130.052239 Z"
                    fill={theme.colors.bgAccent}
                    fillRule="nonzero"
                  />
                  <path
                    d="M19.5743652,30.6492537 L179.201935,30.6492537"
                    stroke={theme.colors.primary}
                    strokeWidth="3.8274"
                    strokeLinecap="round"
                  />
                  <path
                    d="M120.644256,15.0208955 L179.201935,15.0208955"
                    stroke={theme.colors.primary}
                    strokeWidth="3.8274"
                    strokeLinecap="round"
                  />
                  <path
                    d="M19.5743652,41.8597015 L179.201935,41.8597015"
                    stroke={theme.colors.primary}
                    strokeWidth="3.8274"
                    strokeLinecap="round"
                  />
                  <path
                    d="M19.5743652,53.0149254 L179.201935,53.0149254"
                    stroke={theme.colors.primary}
                    strokeWidth="3.8274"
                    strokeLinecap="round"
                  />
                  <path
                    d="M19.5743652,64.2253731 L179.201935,64.2253731"
                    stroke={theme.colors.primary}
                    strokeWidth="3.8274"
                    strokeLinecap="round"
                  />
                  <path
                    d="M19.5743652,75.4358209 L179.201935,75.4358209"
                    stroke={theme.colors.primary}
                    strokeWidth="3.8274"
                    strokeLinecap="round"
                  />
                  <path
                    d="M19.5743652,86.5910448 L179.201935,86.5910448"
                    stroke={theme.colors.primary}
                    strokeWidth="3.8274"
                    strokeLinecap="round"
                  />
                  <path
                    d="M19.5743652,97.8014925 L179.201935,97.8014925"
                    stroke={theme.colors.primary}
                    strokeWidth="3.8274"
                    strokeLinecap="round"
                  />
                  <path
                    d="M19.5743652,109.01194 L179.201935,109.01194"
                    stroke={theme.colors.primary}
                    strokeWidth="3.8274"
                    strokeLinecap="round"
                  />
                  <path
                    d="M3.58403869,130.052239 L197.287545,130.052239 C198.996856,130.052239 200.375333,128.671642 200.375333,126.959701 L200.375333,3.25820896 C200.375333,1.54626866 198.996856,0.165671642 197.287545,0.165671642 L3.58403869,0.165671642 C1.87472793,0.165671642 0.496251511,1.54626866 0.496251511,3.25820896 L0.496251511,127.014925 C0.551390568,128.671642 1.92986699,130.052239 3.58403869,130.052239 Z"
                    fill="url(#linearGradient-3)"
                    fillRule="nonzero"
                    opacity="0.13"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}; /* eslint-enable max-len */
